module.exports = __webpack_public_path__ + "img/heart_11_bj.49a11740.png";